<template>
  <section
    class="relative flex items-center justify-center text-white text-center h-[700px] bg-cover bg-center"
    :style="{ backgroundImage: `url(${bgImage})` }"
  >
    <div class="absolute inset-0 bg-black bg-opacity-60"></div>

    <div class="relative z-10 px-4">
      <img :src="logoImage" alt="Logo OverX" class="mx-auto w-60 md:w-72" />

      <p class="mt-6 text-xl md:text-2xl font-medium leading-snug">
        A gestão completa do seu estabelecimento<br />
        e delivery em um só lugar
      </p>

      <p class="mt-4 max-w-xl mx-auto text-base md:text-lg text-gray-300">
        Descomplique sua operação! Seja no atendimento de mesa,<br />
        delivery ou cozinha, nós facilitamos a gestão do seu negócio.
      </p>

      <a
        :href="whatsappLink"
        target="_blank"
        class="mt-8 inline-block bg-[#FF7A00] text-white font-bold py-3 px-8 rounded-md text-base hover:bg-orange-600 transition"
      >
        Experimente Gratuitamente
      </a>
    </div>
  </section>
</template>

<script>
import bgImage from '@/assets/img2.png'
import logoImage from '@/assets/img3.png'
import { getWhatsAppLink } from '@/utils/whatsapp'

export default {
  name: 'HeroSection',
  data() {
    return {
      bgImage,
      logoImage,
    }
  },
  computed: {
    whatsappLink() {
      return getWhatsAppLink("Olá! Quero experimentar gratuitamente a OverX.");
    },
  },
}
</script>

<style scoped>
</style>
